module.exports = __webpack_public_path__ + "img/bot_bdtd1.cf61cac4.png";